module.exports = __webpack_public_path__ + "static/flags/HM-5be4b961b145059983917680c0375249.gif";